import type { AmountDescriptionMode } from '@components/form/monetary-donations/donate-amount';
import { Meta } from '@components/meta/meta';
import { useRouter } from 'next/router';
import { DonateForm } from 'pages/donate';
import { useEffect } from 'react';

export default function DonateEmbed() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!router.isReady || window.self === window.top) return;
    if (!router.query?.token || !router.query?.campaignName || !router.query?.descriptionMode)
      alert('this donation embed is misconfigured');
    if (
      router.query.descriptionMode !== 'default' &&
      router.query.descriptionMode !== 'donate-bed' &&
      router.query.descriptionMode !== 'donate-furniture'
    )
      alert('please provide a valid description mode');
  }, [router.query, router.isReady]);

  // console.log('embed', router.query);
  if (!router.isReady) return null;

  return (
    <>
      <Meta title="Donate" description="Donate to Beds for Kids" />
      <DonateForm
        fixedCampaign={{ id: String(router.query.token), name: String(router.query.campaignName) }}
        hideCampaign
        embed
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        descriptionMode={String(router.query.descriptionMode) as AmountDescriptionMode}
      />
    </>
  );
}
